<template>
  <div>
    <h1 style="margin: 0 0 5px">Hilo Maintenance</h1>
    <div class="tab-container">
      <div
        class="tab"
        :class="{ selected: selectedTab === 'Assets' }"
        @click="selectTab('Assets')"
      >
        Assets
      </div>
      <div
        class="tab"
        :class="{ selected: selectedTab === 'Parts Search' }"
        @click="selectTab('Parts Search')"
      >
        Parts Search
      </div>
      <button class="add-button" @click="addItem">Add +</button>
      <div v-if="selectedTab === 'Assets'" class="legend">
        <span><span class="inoperable">●</span> Inoperable</span>
        <span><span class="operable">●</span> Operable</span>
        <span
          ><span class="cautionOnlyApprovedFlights">●</span> Caution - Only
          Approved Flights</span
        >
        <span
          ><span class="upcomingMaintenance">●</span> Upcoming Maintenance</span
        >
      </div>
    </div>
    <table v-if="selectedTab === 'Assets'" class="assets-table">
      <tbody>
        <tr
          v-for="asset in getSortedAssets()"
          :key="asset.tailNumber"
          class="assets"
        >
          <td class="status-col">
            <span :class="asset.status">●</span>
          </td>
          <td class="tail-number-col">{{ asset.tailNumber }}</td>
          <td class="priority-col">Priority: {{ asset.priority }}</td>
          <td class="button-group">
            <button class="buttons">Squawks</button>
            <button class="buttons">View Log</button>
          </td>
        </tr>
      </tbody>
    </table>
    <table v-if="selectedTab === 'Parts Search'" class="parts-table">
      <tbody>
        <tr v-for="part in partsList" :key="part.name" class="parts">
          <td>{{ part.name }}</td>
          <td>{{ part.partNumber }}</td>
          <td>{{ part.quantity }}</td>
        </tr>
      </tbody>
    </table>
    <Squawks />
    <div style="margin-top: 30px">
      <div class="tab-container">
        <div class="tab selected">Work Order</div>
        <button class="add-button" @click="addWorkOrder">Add +</button>
        <div class="legend">
          <span><span class="inoperable">●</span> Inoperable</span>
          <span><span class="operable">●</span> Operable</span>
          <span
            ><span class="cautionOnlyApprovedFlights">●</span> Caution - Only
            Approved Flights</span
          >
          <span
            ><span class="upcomingMaintenance">●</span> Upcoming
            Maintenance</span
          >
        </div>
      </div>
      <table class="work-order-table">
        <tbody>
          <tr
            v-for="order in getSortedWorkOrders()"
            :key="order.workOrderNumber"
            class="work-orders"
          >
            <td class="status-col">
              <span :class="order.status">●</span>
            </td>
            <td class="tail-number-col">{{ order.tailNumber }}</td>
            <td class="priority-col">Priority: {{ order.priority }}</td>
            <td class="work-order-col">{{ order.workOrderNumber }}</td>
            <td class="description-col">{{ order.description }}</td>
            <td class="button-group">
              <button class="buttons">View</button>
              <button class="buttons">Logbook</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <coming-soon-modal />
  </div>
</template>

<script>
import Squawks from "./Aircraft/Squawks.vue";
import ComingSoonModal from "@/components/HiloComponents/ComingSoonModal.vue";

export default {
  components: { ComingSoonModal, Squawks },
  data() {
    return {
      selectedTab: "Assets",
      assetsList: [
        { tailNumber: "N145R7", status: "inoperable", priority: 3 },
        { tailNumber: "N246B8", status: "operable", priority: 7 },
        {
          tailNumber: "N347C9",
          status: "cautionOnlyApprovedFlights",
          priority: 5,
        },
        { tailNumber: "N458D0", status: "upcomingMaintenance", priority: 2 },
        { tailNumber: "N569E1", status: "inoperable", priority: 9 },
        { tailNumber: "N670F2", status: "operable", priority: 4 },
      ],
      partsList: [
        { name: "Engine Oil", partNumber: "EO1234", quantity: 50 },
        { name: "Tire", partNumber: "T5678", quantity: 20 },
        { name: "Brake Pad", partNumber: "BP9101", quantity: 35 },
        { name: "Propeller", partNumber: "P1121", quantity: 5 },
        { name: "Wing Tip", partNumber: "WT1314", quantity: 10 },
      ],
      workOrders: [
        {
          tailNumber: "N145R7",
          status: "inoperable",
          priority: 3,
          workOrderNumber: "WO125",
          description: "100hr Inspection - Airframe",
        },
        {
          tailNumber: "N246B8",
          status: "operable",
          priority: 7,
          workOrderNumber: "WO126",
          description: "100hr Inspection - Prop",
        },
        {
          tailNumber: "N347C9",
          status: "cautionOnlyApprovedFlights",
          priority: 5,
          workOrderNumber: "WO127",
          description: "100hr Inspection - Engine",
        },
        {
          tailNumber: "N458D0",
          status: "upcomingMaintenance",
          priority: 2,
          workOrderNumber: "WO128",
          description: "100hr Inspection - AD Check",
        },
        {
          tailNumber: "N569E1",
          status: "inoperable",
          priority: 9,
          workOrderNumber: "WO129",
          description: "100hr Inspection - Airframe",
        },
        {
          tailNumber: "N670F2",
          status: "operable",
          priority: 4,
          workOrderNumber: "WO130",
          description: "100hr Inspection - Prop",
        },
      ],
    };
  },
  methods: {
    selectTab(tab) {
      this.selectedTab = tab;
    },
    addItem() {
      // Add item logic here
    },
    getSortedAssets() {
      return this.assetsList.slice().sort((a, b) => b.priority - a.priority);
    },
    addWorkOrder() {
      // Add work order logic here
    },
    getSortedWorkOrders() {
      return this.workOrders.slice().sort((a, b) => b.priority - a.priority);
    },
  },
};
</script>

<style scoped>
.tab-container {
  display: flex;
  align-items: center;
  margin-bottom: 0;
}

.tab {
  background-color: #888;
  color: white;
  padding: 5px 30px;
  font-size: 16px;
  cursor: pointer;
  margin-right: 0;
  border-radius: 8px 8px 0 0;
}

.tab.selected {
  background-color: #444;
  color: white;
}

.add-button {
  background-color: black;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 3px 16px;
  font-size: 14px;
  cursor: pointer;
  margin-left: 10px;
}

.add-button:hover {
  background-color: #333;
}

.legend {
  display: flex;
  gap: 30px;
  margin-left: auto;
  margin-right: 10px;
}

.legend span {
  font-size: 14px;
  display: flex;
  align-items: center;
}

.legend span span {
  font-size: 1.5em;
  margin-right: 5px;
}

.assets-table,
.parts-table,
.work-order-table {
  width: 100%;
  border: 1px solid lightgrey;
  border-collapse: collapse;
}

.assets-table tr,
.parts-table tr,
.work-order-table tr {
  border-bottom: 1px solid lightgrey;
}

.status-col {
  width: 65px;
}

.tail-number-col {
  width: 120px;
}

.priority-col {
  width: 120px;
}

.work-order-col {
  width: 120px;
  color: lightgray;
}

.description-col {
  width: auto;
}

.assets,
.parts,
.work-orders {
  align-items: center;
  font-size: 16px;
  line-height: 1.2;
}

.assets .inoperable,
.assets .operable,
.assets .cautionOnlyApprovedFlights,
.assets .upcomingMaintenance,
.work-orders .inoperable,
.work-orders .operable,
.work-orders .cautionOnlyApprovedFlights,
.work-orders .upcomingMaintenance {
  margin-right: 10px;
  margin-left: 20px;
  font-size: 2em;
  line-height: 1.2;
  vertical-align: middle;
}

.inoperable {
  color: red;
}

.operable {
  color: green;
}

.cautionOnlyApprovedFlights {
  color: yellow;
}

.upcomingMaintenance {
  color: orange;
}

.button-group {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
  margin-right: 20px;
}

.buttons {
  background-color: black;
  color: white;
  border-radius: 4px;
  border: none;
  font-size: 12px;
  padding: 3px 12px;
}

.buttons:hover {
  background-color: #333;
}

.parts-table td {
  padding: 11px 20px;
}
</style>
